/**
 * Created by chenqifeng on 2016/9/1.
 */
import url                                 from './util/url';
import domain                              from './domain';
import {setCookie,getCookie, removeCookie} from './util/cookie';
import * as api                            from './api/index';
import _                                   from 'lodash'
import tgUrl                               from './util/url';

let Wechat = function() {}
	;

Wechat.prototype.getLocalOpenid = function(appId){
    return getCookie((appId ? (appId+'_') : '') + 'openid');
};
Wechat.prototype.setLocalOpenid = function(openId, appId){
    return setCookie((appId ? (appId+'_') : '') +'openid', openId, '365d');
};
Wechat.prototype.getLocalOpenCypher = function(appId){
    return getCookie((appId ? (appId+'_') : '') + 'openid_cypher');
};
Wechat.prototype.setLocalOpenCypher = function(openIdCypher, appId){
    return setCookie((appId ? (appId+'_') : '') + 'openid_cypher', openIdCypher, '365d');
};
Wechat.prototype.setUnionId = function (unionId) {
    //如果unionId为空，则不进行设定
    return unionId && setCookie('unionId', unionId, '365d');
};
Wechat.prototype.getUnionId = function () {
    return getCookie('unionId');
};
/**
 * 获取 openID 的几种情况
 * 情况：1.本地没有 openId，并且 url 上没有 code 参数 >> 立即跳转页面去换取微信 code
 *      2.本地没有 openId，但是 url 上有 code 参数 >> 调取 weixinService 的接口获取 openId
 *      3.本地存在 openId，则返回 openId
 * @param   params
 * 支持的回调：1.成功获取 >> success(openid, openid_cypher, code)；
 *           2.获取失败 >> fail；
 *           3.任何情况 >> always(openid||undefined, openid_cypher || undefined)
 *
 * 2021-08-06 李银重构了 member，微信登录直接使用 code 登录，不再需要 openId
 * 获取 openId 的接口仍然调用，但是 code 也传回
 */
Wechat.prototype.getOpenidUtil = function(params){
	let that = this
		, urlParams = url.getUrlParams()
		, code = urlParams.code
		, appId = params.appId || domain.appId
		, success = params.success || function(){}
		, fail = params.fail || function(){}
		, always = params.always || function(){}
		, localOpenId = that.getLocalOpenid( appId )
		, localUnionId = that.getUnionId()
		, localOpenIdCypher = that.getLocalOpenCypher( appId )
		;

	// 若 code 为数组，取最后一个
	if( Array.isArray(code) ){
		code = code[code.length - 1];
	}

	// 对应情况 3
	if( localOpenId && localOpenIdCypher && localUnionId ){
		success(localOpenId, localOpenIdCypher
			// , localUnionId
		);
		always(localOpenId, localOpenIdCypher, localUnionId);
	}
	// 对应情况 2
	// code 长度小于 26 则视为无效的 code
	else if( code
		&& (!localOpenId || !localOpenIdCypher || !localUnionId)
		&& code.length > 26
		&& urlParams.state === '_static_openid_flag_' ){

		api.weixin.getOpenid({
			data: {
				code: code
				, appId: appId
			}
			, success: function(data){
				that.setLocalOpenid( data.openid );
				that.setLocalOpenCypher( data.openid_cypher );
				that.setUnionId( data.unionid );
				always( data );

				// /**
				//  * 2021-09-03
				//  * 李银要求使用 openAppId 获取到的 code 才去调用 wechatLogin 接口
				//  *
				//  * 因为 openAppId 需要用户点一些确定，不是静默的
				//  * 现在的登录逻辑都是绑定 unionid 走的，之前老的登录是绑定 openid 方式
				//  * 而 appId 这个现在静默方式只能拿到 openid，拿不到 unionid，所以就先给下了吧
				//  * 就屏蔽，不去调就行了
				//  *
				//  * 以上原话。。。
				//  * 所以将 code 设为空，回调中判断空就不掉 wechatLogin 接口
				//  * */
				// if( appId !== domain.openAppId ){
				// 	code = undefined;
				// }

				success(data.openid, data.openid_cypher, code);
			}
			, error: function(data){
				fail( data );
				always( data );
			}
			, tgError: function(data){
				fail( data );
				always( data );
			}
		});
	}
	// 对应情况 1
	else if( !code && (!localOpenId || !localOpenIdCypher || !localUnionId) ){
		let locationStr = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + (appId || domain.appId)
			;

		locationStr += '&redirect_uri=' + encodeURIComponent(window.location.origin + window.location.pathname + window.location.search + window.location.hash);
		locationStr += '&response_type=code&scope=snsapi_base&state=_static_openid_flag_#wechat_redirect';
		// 跳转至微信 authorize 地址，获取 code
		location.replace( locationStr );
	}
	else{
		fail();
	}
};

Wechat.prototype.sign = function (conf, callback) {
    wx.config(conf);
    wx.ready(callback);
};
Wechat.prototype.setShare = function(opt){
    var that = this;
    if(!wx){
        return false;
    }
    opt = opt || {};
    opt.imgUrl = opt.imgUrl || "//image1.51tiangou.com/tgou2/img2/tgou_logo4.png!s";
    opt.imageUrl = opt.imageUrl || opt.imgUrl;
    // 显示微信功能菜单
    wx.showMenuItems({
        menuList: ["menuItem:share:appMessage", "menuItem:share:timeline",
            "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite",
            "menuItem:share:facebook", "menuItem:share:QZone"]
    });
    opt.link = getShareLink(opt.link);
    // 发送给朋友
    wx.onMenuShareAppMessage({
        title: opt.title || '【大商天狗】大商集团电商平台',    // 分享标题
        desc: opt.subTitle ||  (location && location.href) || 'm.51tiangou.com',            // 分享描述
        link: opt.link || location.href,                    // 分享链接
        imgUrl: opt.imageUrl.replace(/^\/\//, 'http://'),                                 // 分享图标
        success: opt.success,                               //分享成功的回调
        cancel: opt.cancel                                  //取消分享的回调
    });
	// 分享给朋友新版 api
	wx.updateAppMessageShareData && wx.updateAppMessageShareData({
		title: opt.title || '【大商天狗】大商集团电商平台',   // 分享标题
		// link: opt.link,                                         // 分享链接
		desc: opt.subTitle ||  (location && location.href) || 'm.51tiangou.com',            // 分享描述
		link: tgUrl.addParams(opt.link, {
			ENT: timeline
		})
		,
		imgUrl: opt.imageUrl.replace(/^\/\//, 'http://'),                                     // 分享图标
		success: opt.success,                                   //分享成功的回调
		cancel: opt.cancel                                      //取消分享的回调
	});

    //发送给朋友圈
    wx.onMenuShareTimeline({
        title: opt.friendTitle || '【大商天狗】大商集团电商平台',   // 分享标题
        link: opt.link,                                         // 分享链接
        imgUrl: opt.imageUrl.replace(/^\/\//, 'http://'),                                     // 分享图标
        success: opt.success,                                   //分享成功的回调
        cancel: opt.cancel                                      //取消分享的回调
    });
	// 分享给朋友圈新版 api
	wx.updateTimelineShareData && wx.updateTimelineShareData({
		title: opt.friendTitle || '【大商天狗】大商集团电商平台',   // 分享标题
		// link: opt.link,                                         // 分享链接
		link: tgUrl.addParams(opt.link, {
			ENT: timeline
		})
		,
		imgUrl: opt.imageUrl.replace(/^\/\//, 'http://'),                                     // 分享图标
		success: opt.success,                                   //分享成功的回调
		cancel: opt.cancel
	});

    function getShareLink(link) {
        //如果link得域名与当前域名不同的话
        if(link && link.indexOf(domain.baseService)<0){
            return 'https:'+domain.baseService+'/qr.html?id=redirect_'+encodeURIComponent(link);
        }else{
            return link;
        }
    }

};

Wechat.prototype.hideMenu = function () {
    var that = this;
    wx.hideMenuItems({
        menuList: ["menuItem:share:appMessage", "menuItem:share:timeline",
            "menuItem:share:qq", "menuItem:share:weiboApp",
            "menuItem:favorite", "menuItem:share:facebook",
            "menuItem:share:QZone"]
    });
};


Wechat.prototype.setOpenidByAppid = function (params) {
	var appId = params.appId || params.appid || domain.appId,
		openId = params.openId || params.openid,
		openid_cypher = params.openid_cypher,
		expireDay = params.expire || 365;
	if(appId === domain.appId){
		//设置对应的openId和openid_cypher
		openId && setCookie('openid', openId, expireDay);
		openid_cypher && setCookie('openid_cypher', openid_cypher, expireDay);
	}else{
		//设置对应的openId和openid_cypher
		openId && setCookie('openid_'+appId, openId, expireDay);
		openid_cypher && setCookie('openid_cypher_'+appId, openid_cypher, expireDay);
	}

};

/**
 * 获取微信用户个人信息的通用方法
 * @param params.callback   获取用户信息的回调，参数是用户信息（类型Object）
 *          params.appId    公众号AppId，可以根据不同AppId取得对应的openId。默认用当前环境的AppId。
 *
 * 功能说明：可以获取当前微信用户的头像、性别、昵称、openId等信息
 *
 * 方法流程：流程之上而下的逻辑优先顺序如下：
 *          1.如果cookies中存在了用户信息，则直接返回cookies中的用户信息，cookies中的保存时间暂时定为7天
 *          2.如果cookies中存在access_token和openId时，则利用这两个值来调用后台接口来换取用户信息（获取后缓存至cookie）
 *          3.如果url上带有code和state参数，则利用code来调用后台接口来换取用户信息(获取后缓存至cookie)和access_token（此值缓存至cookie，用来调用步骤2）
 *          4.以上条件都不满足，说明该用户比较纯洁，第一次浏览该页面。此时，直接跳转至“微信鉴权页面”去换取code
 */
Wechat.prototype.getUserInfoUtil = function(params){
	var appId = params.appId || params.appid || domain.appId,
		isDefaultAppId = appId === domain.appId,
		callback = params.callback || function(){},
		urlParams = url.getUrlParams(true,true),
		STATE_NAME = 'wechat_util',
		COOKIE_EXPIRE_DAYS = 7,
		openid_c = this.getLocalOpenid(appId),    //cookie中的openId
		userInfo_c = isDefaultAppId? getCookie('userInfo'): getCookie('userInfo_'+appId),
		access_token_c = isDefaultAppId? getCookie('access_token'): getCookie('access_token_'+appId),
		code_url = _.isArray(urlParams.code)?urlParams.code[urlParams.code.length-1]:urlParams.code,
		state_url = _.isArray(urlParams.state)?urlParams.state[urlParams.state.length-1]:urlParams.state;

	if (userInfo_c){
		callback(JSON.parse(userInfo_c));
	}else if (access_token_c && openid_c){
		// WeixinService.getUserInfoByAccessToken({
		api.weixin.getUserInfoByAccessToken({
			data: {
				access_token: access_token_c,
				openid: openid_c
			},
			success:function(data){
				//缓存用户信息
				isDefaultAppId?setCookie('userInfo', JSON.stringify(data), COOKIE_EXPIRE_DAYS):setCookie('userInfo_'+appId, JSON.stringify(data), COOKIE_EXPIRE_DAYS);
				//保存openId
				this.setOpenidByAppid({
					appId: appId,
					openId: data.openid,
					openid_cypher: data.openid_cypher
				});
				callback(data)
			}.bind(this),
			tgError:function(errorData){
				if(errorData.code == 503) {
					//access_token已经过期了,清楚缓存中的access_token
					isDefaultAppId?setCookie('access_token',''):setCookie('access_token_'+appId,'');
					isDefaultAppId?removeCookie('access_token',''):removeCookie('access_token_'+appId,'');
					location.replace(_getWxAuthUrl(appId));
				// } else {
				// 	notice && $.that.notice(errorData.message);
				}
			}.bind(this)
		})
	}else if(code_url && state_url === STATE_NAME){
		//已授权（刚授权），来获取access_token
		api.weixin.getInfoByCode({
			data: {code: code_url, appid: appId},
			success: function (data) {
				var access_token = data.access_token,
					d = new Date(),
					time = d.getTime() + 7200 * 1000;   //缓存两小时

				//
				isDefaultAppId?setCookie('access_token', access_token, new Date(time)):setCookie('access_token_'+appId, access_token, new Date(time));
				// alert(JSON.stringify(data && data.userInfo));
				//保存用户信息
				try{
					isDefaultAppId?setCookie('userInfo', JSON.stringify(data && data.userInfo), COOKIE_EXPIRE_DAYS):setCookie('userInfo_'+appId, JSON.stringify(data && data.userInfo), COOKIE_EXPIRE_DAYS);
				}
				catch(e){
					alert(e.message);
				}
				// alert(12311111231233);
				//保存openid
				this.setOpenidByAppid({
					appId: appId,
					openId: data.userInfo && (data.userInfo.openid || data.userInfo.openId),
					openid_cypher: data.openid_cypher      //这里把openId当做openId——cypher来处理
				});
				callback(data.userInfo);
			}.bind(this)
		})
	}else{
		//未授权，需跳转至微信授权页面
		location.replace(_getWxAuthUrl(appId));
	}

	function _getWxAuthUrl(appid) {
		return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid
			+ '&redirect_uri=' + encodeURIComponent(window.location.origin + window.location.pathname + window.location.search+window.location.hash)
			+ '&response_type=code&scope=snsapi_userinfo&state='+STATE_NAME+'#wechat_redirect';
	}
};

export default new Wechat();